"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _react = _interopRequireDefault(require("react"));

var _tag = require("baseui/tag");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Root = {
  style: function style(_ref) {
    var $theme = _ref.$theme;
    var colors = $theme.colors;
    return {
      backgroundColor: colors.primary700,
      color: colors.mono200
    };
  }
};

var Tag = function Tag(_ref2) {
  var closeable = _ref2.closeable,
      children = _ref2.children,
      kind = _ref2.kind,
      variant = _ref2.variant,
      rest = _objectWithoutProperties(_ref2, ["closeable", "children", "kind", "variant"]);

  return _react["default"].createElement(_tag.Tag, _extends({
    closeable: closeable,
    kind: kind,
    variant: variant,
    overrides: {
      Root: Root
    }
  }, rest), children);
};

exports.Tag = Tag;
Tag.propTypes = {
  closeable: _propTypes.bool,
  children: _propTypes.node.isRequired,
  kind: _propTypes.string,
  variant: _propTypes.string
};
Tag.defaultProps = {
  closeable: false,
  kind: _tag.KIND.neutral,
  variant: _tag.VARIANT.solid
};